import styled from 'styled-components'
import { Menu } from 'antd'

export const MenuItem = styled(Menu.Item)`
  height: 32px;
`
